const silent = process.env.NODE_ENV != 'development'

const info = '#1f59a4'
const warn = '#d2b516'
const error = '#ff0000'

export default {
	log() { this._print(console.log, info, ...arguments) },
	error() { this._print(console.error, error, ...arguments) },
	warn() { this._print(console.warn, warn, ...arguments) },

	_print(logger, color, packageName, ...rest) {
		if(!silent) logger(`%c[${packageName}]`,  `color: ${color}`, ...rest)
	},
}